import { STORE_BROKER_FIELD_DETAILS } from '../actions/storeBrokerFieldDetailsActions';;

interface BrokerFields {
    'host': string,
    'messageVpn': string,
    'clientUsername': string,
    'clientPassword': string
}

export let getBrokerFieldDetailSelector  =  (state: BrokerFields) => {
    return state[STORE_BROKER_FIELD_DETAILS];
  };
  